import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import OrganizationsSettingsComponent from '../components/organization.component';
import { organizationSettings } from '../../../../../redux/organizations-setting/action';
import { selectOrganizationSettingsQueryItems } from '../../../../../redux/organizations-setting/selector';

const ManagementOrganizationsSettings = () => {
  const dispatch = useAppDispatch()
  const organizationSettingsQuery = useSelector(selectOrganizationSettingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectOrganizationsSettings, setSelectOrganizationsSettings] = useState<any>([])

  const fetchOrganizationsSettingsQueryById = () => {
    dispatch(organizationSettings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/organizations/query`,
      entity: 'organizationSettings',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectOrganizationsSettings({ ...selectOrganizationsSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchOrganizationsSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectOrganizationsSettings(organizationSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(organizationSettings.resetAction({ actionType: 'update' }))
    await dispatch(organizationSettings.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/organizations`,
      entity: 'organizationSettings',
      jsonData: {
        Records: [
          selectOrganizationsSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <OrganizationsSettingsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectOrganizationsSettings={selectOrganizationsSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementOrganizationsSettings;